import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import AppShell from "./components/AppShell";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicOnlyRoute from "./components/PublicOnlyRoute";
import { LanguageProvider } from "./lib/language";
import Login from "./pages/Login";
import AdminPanel from "./pages/AdminPanel";
import AdminCoursesPage from "./pages/AdminCoursesPage";
import AdminStudentsPage from "./pages/AdminStudentsPage";
import AdminTrainersPage from "./pages/AdminTrainersPage";
import Register from "./pages/Register";
import TermsPage from "./pages/TermsPage";
import ProfilePage from "./pages/ProfilePage";
import StudentExam from "./pages/StudentExam";
import TrainerAiStudio from "./pages/TrainerAiStudio";
import TrainerCoursesPage from "./pages/TrainerCoursesPage";
import TrainerAnalyticsPage from "./pages/TrainerAnalyticsPage";
import TrainerResultsPage from "./pages/TrainerResultsPage";
import TrainerOverviewPage from "./pages/TrainerOverviewPage";

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/terms" element={<TermsPage />} />

          <Route element={<PublicOnlyRoute />}>
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Route>

          <Route element={<ProtectedRoute roles={["student", "trainer", "admin"]} />}>
            <Route element={<AppShell />}>
              <Route path="/profile" element={<ProfilePage />} />

              <Route element={<ProtectedRoute roles={["student"]} />}>
                <Route path="/exam" element={<StudentExam />} />
              </Route>

              <Route element={<ProtectedRoute roles={["trainer"]} />}>
                <Route path="/dashboard" element={<TrainerResultsPage />} />
                <Route path="/trainer-overview" element={<TrainerOverviewPage />} />
                <Route path="/trainer-analytics" element={<TrainerAnalyticsPage />} />
                <Route path="/trainer-results" element={<TrainerResultsPage />} />
                <Route path="/ai-studio" element={<TrainerAiStudio />} />
                <Route path="/courses" element={<TrainerCoursesPage />} />
              </Route>

              <Route element={<ProtectedRoute roles={["admin"]} />}>
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/admin/trainers" element={<AdminTrainersPage />} />
                <Route path="/admin/students" element={<AdminStudentsPage />} />
                <Route path="/admin/courses" element={<AdminCoursesPage />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
